import { render, staticRenderFns } from "./notificationReport.vue?vue&type=template&id=7ff28d6b"
import script from "./notificationReport.vue?vue&type=script&lang=js"
export * from "./notificationReport.vue?vue&type=script&lang=js"
import style0 from "./notificationReport.vue?vue&type=style&index=0&id=7ff28d6b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports